module.exports = __webpack_public_path__ + "img/方膜.2fff3bb1.jpg";